import api from './apiClient';
import { guestApiPath } from './guestApiPath';
import { getGuestAuthToken, hasPreviewSessionToken, isPreviewToken } from './utils/guestToken';

export const REPORT_REASONS = [
  ['intimate_image_abuse', 'Intimate images shared without consent'],
  ['child_abuse', 'Sexual or abusive images of a child'],
  ['doxxing', 'Personal details shared to cause harm'],
  ['harassment', 'Harassment or threats'],
  ['stalking', 'Stalking'],
  ['copyright', 'Copyright infringement'],
  ['other', 'Other'],
];

export async function reportMedia(galleryId, report) {
  const token = getGuestAuthToken();
  if (hasPreviewSessionToken() || isPreviewToken(token)) {
    throw new Error('Reports cannot be sent from a preview.');
  }
  const { data } = await api.post(guestApiPath('/reports', galleryId), report, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export function reportErrorMessage(error) {
  if (error?.response?.status === 400 && error.response.data?.error === 'BAD_REQUEST'
    && [
      'Contact must be an email address or phone number of at most 254 characters.',
      'Enter an email address or phone number for the outcome.',
    ].includes(error.response.data.message)) {
    return 'Enter a valid email address or WhatsApp phone number, or leave contact blank.';
  }
  if (error?.response?.status === 429) {
    const seconds = Number(error.response.data?.retryAfterSeconds);
    return Number.isFinite(seconds) && seconds > 0
      ? `Too many reports. Please try again in ${Math.ceil(seconds)} seconds.`
      : 'Too many reports. Please wait a little before trying again.';
  }
  return 'Your report could not be sent. Please try again.';
}
